import * as React from 'react';

import {isBinaryFile, getBinaryMimeType, getAdjustedFontStyle} from './_util';
import {Button, Icon, RangeSlider} from '../util';
import CodeEditor from './util/CodeEditor';

interface AssetEditorProps {
	editing: ConfigEditor.AssetEditorState;
	isModified: boolean;
	validationError: string;
	fontSizeAdjustment: number;
	onChange(contents: string): void;
	onSave(): void;
	onRevert(): void;
	onAdjustFontSize(fontSize: number): void;
}

const DEFAULT_PATH_FONT_SIZE: number = 13;

export default class AssetEditor extends React.Component<AssetEditorProps, {}> {

	public render() {
		return <div className='asset-view'>
			<div className='asset-editor'>
				<div className='title-bar'>
					{this.renderPath()}
					{this.renderValidationIcon()}
					<div className='asset-editor-right-buttons'>
						{this.renderFontSizeSlider()}
						{this.renderRevertChangesButton()}
						{this.renderConfirmChangesButton()}
					</div>
				</div>
				{this.renderEditor()}
			</div>
		</div>;
	}

	private renderFontSizeSlider() {
		return <RangeSlider
			value={this.props.fontSizeAdjustment}
			onChange={this.props.onAdjustFontSize}
		/>;
	}

	private renderRevertChangesButton() {
		return <Button
			size='small'
			color='green'
			disabled={!this.props.isModified}
			onClick={this.props.onRevert}
		>
			<Icon name='undo' /> Revert
		</Button>;
	}

	private renderConfirmChangesButton() {
		return <Button
			size='small'
			color='green'
			disabled={!this.props.isModified}
			onClick={this.props.onSave}
		>
			<Icon name='save' /> Confirm
		</Button>;
	}

	private renderPath() {
		const parts = this.props.editing.path.split('/');
		return parts.map((part, index) => {
			if (this.isDownloadable(part)) {
				return <span
					key={index}
					style={getAdjustedFontStyle(DEFAULT_PATH_FONT_SIZE, this.props.fontSizeAdjustment)}
				>
					{index > 0 && <Icon name='chevron-right' fixedWidth />}
					{this.renderDownloadablePathPart(part, index)}
				</span>;
			} else {
				return <span
					key={index}
					style={getAdjustedFontStyle(DEFAULT_PATH_FONT_SIZE, this.props.fontSizeAdjustment)}
				>
					{index > 0 && <Icon name='chevron-right' fixedWidth />}
					{part}
				</span>;
			}
		});
	}

	private renderDownloadablePathPart(part: string, index: number) {
		const binaryContents = this.props.editing.contents;
		const binaryMimeType = getBinaryMimeType(part);
		return <a
			key={index}
			href={`data:${binaryMimeType};base64,${binaryContents}`}
			download={part}
		>
			{part}
		</a>;
	}

	private renderValidationIcon() {
		if (this.props.validationError) {
			return <div
				className='asset-tooltip'
				data-tooltip={this.props.validationError}
			>
				<Icon name='warning' className='error-icon' fixedWidth />
			</div>;
		} else {
			return null;
		}
	}

	private renderEditor() {
		try {
			return <CodeEditor
				editing={this.props.editing}
				onChange={this.props.onChange}
				fontSizeAdjustment={this.props.fontSizeAdjustment}
			/>;
		} catch (error) {
			return this.renderEditorError(error);
		}
	}

	private renderEditorError(error: Error) {
		return <div className='asset-contents asset-contents-error'>
			<p>The editor for this file cannot be shown due to an error.</p>
			<p>Error: {error.message}</p>
		</div>;
	}

	private isDownloadable(assetPath: string) {
		return isBinaryFile(assetPath);
	}

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/components/config-editor/AssetEditor.tsx